import { Injectable } from '@angular/core';
import { ApiService, ElementApiService, ElementsService } from 'dbweb-core';
import { from } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { IColumnType } from '../../services/eleview/types/model';
import { ElementViewDigest } from '../model/element-columns-digest';
import {
	IDisplayColumn,
	IElementViewDigest,
	IFetchDataParam,
	IFetchDataResultType,
	IFetchParamResult,
	IFetchRowCountResult
} from '../model/model';

interface CacheFetchParam {
	timeOutTime: Date;
	data: IFetchParamResult;
}

interface UpdateViewParam {
	Name: string;
	OwnerBy: string;
	Owner: string;
	Columns: IDisplayColumn[];
}
interface UpdateViewNameParam {
	OldName: string;
	Name: string;
	OwnerBy: string;
	Owner: string;
}
interface BuildRecordViewURLParam {
	Title: string;
	Condition: string;
	More?: string[];
}

@Injectable()
export class BackFaceService {
	public eleName: string;
	public url: string;
	paramCache = new Map<string, CacheFetchParam>();
	constructor(private eleApi: ElementApiService, private api: ApiService, private eles: ElementsService) {}
	buildRecordViewURL(param: BuildRecordViewURLParam) {
		return this.eleApi.get<string>(this.eleName, 'build-record-view-url', param);
	}
	private apiGet<T>(method: string, param?: any) {
		return this.api.get<T>(this.url, method, this.eles.getURLSign(this.url), param);
	}
	private apiPost<T>(method: string, param?: any) {
		return this.api.post<T>(this.url, method, this.eles.getURLSign(this.url), param);
	}
	fetchRowCount(param: IFetchDataParam) {
		return this.apiPost<IFetchRowCountResult>('fetch-row-count', param);
	}
	fetchData(param: IFetchDataParam) {
		const startTime = new Date().getTime();
		return this.apiPost<IFetchDataResultType>('fetch-data', param).pipe(
			map(v => ({ ...v, TimeConsuming: (new Date().getTime() - startTime) / 1000 }))
		);
	}

	fetParamCache() {
		if (this.paramCache.has(this.eleName)) {
			const data = this.paramCache.get(this.eleName);
			// å¦ææ²¡æè¶æ¶åè¿å
			if (data.timeOutTime > new Date()) {
				return from([data.data]);
			}
		}
		// console.log('fetch', eleName, 'param');
		return this.apiGet<IFetchParamResult>('fetch-param').pipe(
			tap(val => {
				const date = new Date();
				date.setTime(date.getTime() + 5 * 1000 * 60); // 5åéè¶æ¶

				this.paramCache.set(this.eleName, { timeOutTime: date, data: val });
			})
		);
	}
	fetchAllColumns() {
		return this.apiGet<IColumnType[]>('fetch-all-columns');
	}

	// è·åè§å¾æ¸å
	fetchElementViewList() {
		return this.apiGet<IElementViewDigest[]>('fetch-element-view-list', this.eleName).pipe(
			map(v => v.map(vv => ElementViewDigest.fromInterface(vv)))
		);
	}
	getViewColumns(param: IElementViewDigest) {
		return this.apiGet<IDisplayColumn[]>('get-view-columns', param);
	}
	// æ°å¢è§å¾ï¼åªæåç§°ï¼æ²¡æåå®¹
	addView(param: IElementViewDigest) {
		return this.apiPost<boolean>('add-view', param);
	}
	// æ´æ°è§å¾
	updateView(param: UpdateViewParam) {
		return this.apiPost<boolean>('update-view', param);
	}
	// æ´æ°è§å¾åç§°
	updateViewName(param: UpdateViewNameParam) {
		return this.apiPost<boolean>('update-view-name', param);
	}
	// å é¤è§å¾
	removeView(param: IElementViewDigest) {
		return this.apiPost<boolean>('remove-view', param);
	}
	// è¿åå¤ä¸ªæ ç­¾çæ¶åå
	comboLabelsView() {
		return this.apiGet<string[]>('combo-labels-view');
	}
}
